module.exports = __webpack_public_path__ + "img/reserve-active.748a05a0.png";